export const AI_PROMPT_DESCRIPTIONS: Record<string, string> = {
  call_grade:
    'Введите промпт для оценки записи разговора по 100-балльной шкале и подготовки рекомендаций оператору по улучшению качества общения с клиентами.',
};
